export function translateToMins(duration: number, m: string, h: string) {
  const hours = Math.floor(duration / 60 / 60 / 1000)
  if (hours === 0) {
      return quickPlural(Math.floor((duration) / 60 / 1000), m)
  } else {
      const mod = duration - hours * 60 * 60 * 1000
      return (
          hours === 0 ? (
              ''
          ) : (
              quickPlural(hours, h) + ' '
          )
      ) + quickPlural(Math.floor(mod / 60 / 1000), m)
  }
}

const quickPlural = (count: number, noun: string) => {
  if (noun.length === 1) {
      return `${count}${noun}`
  }

  if (count === 1) {
      return `${count} ${noun}`
  }
  return `${count} ${noun}s`
}
